import React from 'react'
import { useIntl } from 'react-intl'
import messages from '@utils/messages'
import { Info } from '@mui/icons-material'
import Tooltip from '@mui/material/Tooltip'
import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()((theme) => ({
  infoIcon: {
    cursor: 'pointer',
    color: theme.palette.primary.main,
  },
}))

export interface AdditionalInfoIconProps {
  setDialogOpen: (boolean) => void
}

const AdditionalInfoIcon: React.FC<AdditionalInfoIconProps> = ({
  setDialogOpen,
}) => {
  const { classes } = useStyles()
  const { formatMessage } = useIntl()

  return (
    <Tooltip
      title={formatMessage(messages.ADDITIONAL_INFO_POPOVER)}
      placement="top"
      enterDelay={1000}
    >
      <Info className={classes.infoIcon} onClick={() => setDialogOpen(true)} />
    </Tooltip>
  )
}

export default AdditionalInfoIcon
